import {
  ExternalPerformanceReview,
  ReviewStatus,
  PerformanceRating,
  ExternalPartnerType,
  PerformanceSummary,
} from '../../views/modules/analytics/performance/performance.interfaces';

export const mockExternalPerformanceReviews: ExternalPerformanceReview[] = [
  {
    id: 'external-1',
    partnerId: 'EXT001',
    name: 'ABC Catering Services',
    partnerType: ExternalPartnerType.SERVICE_PROVIDER,
    contractNumber: 'CNT-2024-001',
    serviceDomain: 'Food and Beverage Services',
    contractStartDate: '2024-01-01',
    contractEndDate: '2024-12-31',
    reviewPeriod: 'Q2 2024',
    reviewDate: '2024-07-30',
    reviewer: 'Mrs. Kavita Singh (Operations Manager)',
    status: ReviewStatus.COMPLETED,
    overallRating: PerformanceRating.GOOD,
    overallScore: 82,
    comments:
      'ABC Catering provides consistent quality food services with good hygiene standards.',
    strengths: [
      'Consistent food quality',
      'Good hygiene practices',
      'Timely service delivery',
      'Responsive to feedback',
    ],
    areasForImprovement: [
      'Menu variety for special diets',
      'Cost optimization',
      'Staff training for customer service',
    ],
    goals: [
      'Introduce more healthy menu options',
      'Reduce food wastage by 15%',
      'Improve customer satisfaction scores',
      'Implement digital ordering system',
    ],
    nextReviewDate: '2024-10-30',
    serviceMetrics: [
      {
        metric: 'Food Quality Score',
        target: '4.0/5.0',
        actual: '4.2/5.0',
        status: 'exceeded',
      },
      {
        metric: 'Service Timeliness',
        target: '95%',
        actual: '92%',
        status: 'below',
      },
      {
        metric: 'Hygiene Compliance',
        target: '100%',
        actual: '100%',
        status: 'met',
      },
      {
        metric: 'Customer Satisfaction',
        target: '4.0/5.0',
        actual: '3.8/5.0',
        status: 'below',
      },
    ],
    complianceAssessment: {
      regulatory: PerformanceRating.EXCELLENT,
      safety: PerformanceRating.EXCELLENT,
      quality: PerformanceRating.GOOD,
      timeliness: PerformanceRating.SATISFACTORY,
    },
    contractRenewalRecommendation: true,
    costEffectiveness: PerformanceRating.GOOD,
  },
  {
    id: 'external-2',
    partnerId: 'EXT002',
    name: 'SecureGuard Security Solutions',
    partnerType: ExternalPartnerType.SERVICE_PROVIDER,
    contractNumber: 'CNT-2024-002',
    serviceDomain: 'Security Services',
    contractStartDate: '2024-03-01',
    contractEndDate: '2025-02-28',
    reviewPeriod: 'Q2 2024',
    reviewDate: '2024-07-25',
    reviewer: 'Mr. Rajesh Kumar (Administration Head)',
    status: ReviewStatus.COMPLETED,
    overallRating: PerformanceRating.EXCELLENT,
    overallScore: 91,
    comments:
      'SecureGuard provides excellent security services with professional staff and modern equipment.',
    strengths: [
      'Professional security personnel',
      'Modern security equipment',
      'Excellent incident response',
      'Comprehensive reporting',
      'Strong compliance record',
    ],
    areasForImprovement: [
      'Cost optimization opportunities',
      'Technology upgrade schedule',
    ],
    goals: [
      'Implement facial recognition system',
      'Reduce security incidents by 20%',
      'Improve response time to under 2 minutes',
      'Complete advanced security training',
    ],
    nextReviewDate: '2024-10-25',
    serviceMetrics: [
      {
        metric: 'Incident Response Time',
        target: '< 3 minutes',
        actual: '< 2 minutes',
        status: 'exceeded',
      },
      {
        metric: 'Security Coverage',
        target: '100%',
        actual: '100%',
        status: 'met',
      },
      {
        metric: 'Equipment Uptime',
        target: '98%',
        actual: '99.5%',
        status: 'exceeded',
      },
      {
        metric: 'Staff Attendance',
        target: '95%',
        actual: '97%',
        status: 'exceeded',
      },
    ],
    complianceAssessment: {
      regulatory: PerformanceRating.EXCELLENT,
      safety: PerformanceRating.EXCELLENT,
      quality: PerformanceRating.EXCELLENT,
      timeliness: PerformanceRating.EXCELLENT,
    },
    contractRenewalRecommendation: true,
    costEffectiveness: PerformanceRating.GOOD,
  },
  {
    id: 'external-3',
    partnerId: 'EXT003',
    name: 'CleanPro Maintenance',
    partnerType: ExternalPartnerType.CONTRACTOR,
    contractNumber: 'CNT-2024-003',
    serviceDomain: 'Cleaning and Maintenance',
    contractStartDate: '2024-04-01',
    contractEndDate: '2025-03-31',
    reviewPeriod: 'Q2 2024',
    reviewDate: '2024-07-28',
    reviewer: 'Mrs. Meera Joshi (Facilities Manager)',
    status: ReviewStatus.IN_PROGRESS,
    overallRating: PerformanceRating.SATISFACTORY,
    overallScore: 68,
    comments:
      'CleanPro provides adequate maintenance services but needs improvement in consistency and quality control.',
    strengths: [
      'Affordable pricing',
      'Flexible scheduling',
      'Quick response to urgent requests',
      'Eco-friendly cleaning products',
    ],
    areasForImprovement: [
      'Consistency in service quality',
      'Staff training and supervision',
      'Equipment maintenance',
      'Communication and reporting',
    ],
    goals: [
      'Improve service consistency',
      'Implement quality control system',
      'Upgrade cleaning equipment',
      'Provide regular staff training',
    ],
    nextReviewDate: '2024-10-28',
    serviceMetrics: [
      {
        metric: 'Cleanliness Score',
        target: '4.0/5.0',
        actual: '3.2/5.0',
        status: 'below',
      },
      {
        metric: 'Task Completion Rate',
        target: '98%',
        actual: '85%',
        status: 'below',
      },
      {
        metric: 'Equipment Functionality',
        target: '95%',
        actual: '78%',
        status: 'below',
      },
      {
        metric: 'Response Time',
        target: '< 4 hours',
        actual: '< 3 hours',
        status: 'exceeded',
      },
    ],
    complianceAssessment: {
      regulatory: PerformanceRating.GOOD,
      safety: PerformanceRating.SATISFACTORY,
      quality: PerformanceRating.NEEDS_IMPROVEMENT,
      timeliness: PerformanceRating.SATISFACTORY,
    },
    contractRenewalRecommendation: false,
    costEffectiveness: PerformanceRating.GOOD,
  },
];

export const mockExternalPerformanceSummary: PerformanceSummary = {
  totalReviews: 3,
  completedReviews: 2,
  pendingReviews: 1,
  overdueReviews: 0,
  averageRating: 8.0,
  ratingDistribution: {
    excellent: 1,
    good: 1,
    satisfactory: 1,
    needsImprovement: 0,
    unsatisfactory: 0,
  },
};
